module.exports = __webpack_public_path__ + "images/FUSA_icons/036-credit-card-2.5e953ecda4fb94dc4eff597517d53f7a.svg";